var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:{active: _vm.isActive},on:{"click":function($event){return _vm.$modalityStore.toggleModal({name: _vm.name, type: 'drawer', noTint: _vm.noTint})}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }